import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  cta,
}) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {eyebrow && (
        <div
          className={`text-xs font-bold uppercase tracking-[0.22em] text-bronze ${
            align === "center" ? "" : ""
          }`}
        >
          {eyebrow}
        </div>
      )}
      <h2 className="mt-3 font-display font-bold text-ink text-3xl sm:text-4xl leading-tight tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-ink-muted text-base sm:text-lg leading-relaxed">
          {subtitle}
        </p>
      )}
      {cta && (
        <Link
          to={cta.to}
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brand-mid"
        >
          {cta.label} <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
}
